import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { GtmService } from '../gtm.service';

export const routeChangeActivateGuard: CanActivateFn = (route) => {
  const gtmService = inject(GtmService);
  gtmService.routingActivation('route', route.url);
  return true;
};
